import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";

export function useHolidayDelete() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function deleteHoliday(idFeriado) {
		if (!idFeriado) {
			const message = "Não foi possível identificar o feriado para exclusão.";

			setError(message);

			return {
				ok: false,
				reason: "validation",
				error: message
			};
		}

		try {
			setLoading(true);
			setError(null);

			const { accessToken, clientId } = getAuthParams();

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/feriados/${idFeriado}`,
				{
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						"access_token": accessToken,
						"client_id": clientId
					}
				}
			);

			if (!response.ok) {
				await throwResponseError(response, "Erro ao excluir feriado.");
			}

			return {
				ok: true
			};
		} catch (requestError) {
			const errorMessage =
				requestError.message || "Erro ao excluir feriado.";

			setError(errorMessage);

			return {
				ok: false,
				reason: "request",
				error: errorMessage
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		loading,
		error,
		deleteHoliday
	};
}